module.exports = __webpack_public_path__ + "a1951685fa3474f6eb8c306adbe6204a.png";